// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.number-input {
    border: 1px solid var(--border-color);
    position: relative;
    display: flex;
    height: 2em;
    background-color: var(--input-bg-color);
    align-items: center;
}

div.number-input > input {
    min-width: 0;
    width: 0;
    flex: 1 1 auto;
    border: 0!important;
    height: calc(2em - 2px)!important;
    background-color: transparent!important;
}

div.number-input-disabled > span.icon {
    color: var(--text-color-disabled);
    cursor: default;
}

div.number-input:not(.number-input-disabled) > span.icon:hover {
    background-color: var(--button-bg-color-hover);
}

/** Normal **/
div.number-input-normal > input {
    padding-right: 1.5em;
}

div.number-input > span.icon-chevron-up,
div.number-input > span.icon-chevron-down {
    position: absolute;
    right: 0;
    width: 1.5em;
    height: 1em;
    user-select: none;
}

div.number-input > span.icon-chevron-up {
    top: calc(50% - 1em);
}

div.number-input > span.icon-chevron-down {
    bottom: calc(50% - 1em);
}

/** Mobile **/
div.number-input-mobile > input {
    padding: 0 2em;
    text-align: center;
}

div.number-input > span.icon-plus,
div.number-input > span.icon-minus {
    position: absolute;
    top: 1px;
    bottom: 1px;
    width: 2em;
    background-color: var(--button-bg-color);
    border: 1px solid var(--border-color);
    border-radius: 2px;
    user-select: none;
}

div.number-input > span.icon-plus {
    right: 1px;
}

div.number-input > span.icon-minus {
    left: 1px;
}
`, "",{"version":3,"sources":["webpack://./qwc2/components/widgets/style/NumberInput.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,uCAAuC;IACvC,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,QAAQ;IACR,cAAc;IACd,mBAAmB;IACnB,iCAAiC;IACjC,uCAAuC;AAC3C;;AAEA;IACI,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,8CAA8C;AAClD;;AAEA,aAAa;AACb;IACI,oBAAoB;AACxB;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA,aAAa;AACb;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,UAAU;IACV,wCAAwC;IACxC,qCAAqC;IACrC,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,SAAS;AACb","sourcesContent":["div.number-input {\n    border: 1px solid var(--border-color);\n    position: relative;\n    display: flex;\n    height: 2em;\n    background-color: var(--input-bg-color);\n    align-items: center;\n}\n\ndiv.number-input > input {\n    min-width: 0;\n    width: 0;\n    flex: 1 1 auto;\n    border: 0!important;\n    height: calc(2em - 2px)!important;\n    background-color: transparent!important;\n}\n\ndiv.number-input-disabled > span.icon {\n    color: var(--text-color-disabled);\n    cursor: default;\n}\n\ndiv.number-input:not(.number-input-disabled) > span.icon:hover {\n    background-color: var(--button-bg-color-hover);\n}\n\n/** Normal **/\ndiv.number-input-normal > input {\n    padding-right: 1.5em;\n}\n\ndiv.number-input > span.icon-chevron-up,\ndiv.number-input > span.icon-chevron-down {\n    position: absolute;\n    right: 0;\n    width: 1.5em;\n    height: 1em;\n    user-select: none;\n}\n\ndiv.number-input > span.icon-chevron-up {\n    top: calc(50% - 1em);\n}\n\ndiv.number-input > span.icon-chevron-down {\n    bottom: calc(50% - 1em);\n}\n\n/** Mobile **/\ndiv.number-input-mobile > input {\n    padding: 0 2em;\n    text-align: center;\n}\n\ndiv.number-input > span.icon-plus,\ndiv.number-input > span.icon-minus {\n    position: absolute;\n    top: 1px;\n    bottom: 1px;\n    width: 2em;\n    background-color: var(--button-bg-color);\n    border: 1px solid var(--border-color);\n    border-radius: 2px;\n    user-select: none;\n}\n\ndiv.number-input > span.icon-plus {\n    right: 1px;\n}\n\ndiv.number-input > span.icon-minus {\n    left: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
